/* global $:true */
import plugin from '../../lib/plugin';
import { onAvailable } from "../../lib/selectors";

const ELEMENT_SELECTOR = '[data-trigger-event]';
const PLUGIN_NAME = 'triggerEvent';


export function exec() {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--trigger-event" */ './plugin.js'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/trigger-event/index.js